import React, { useEffect, useState } from "react";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import EstacionamientoService from "../services/EstacionamientoService";
import { Modal, ModalBody, ModalHeader, Label, ModalFooter, Button, Spinner} from "reactstrap";
import bodySiteM from "./BodySiteM.module.css";


const MiCuentaSites = () => {
    const navigate = useNavigate();
    const [userData, setUserData] = useState({});
    const [loading, setLoading] = useState(true);
    const [modalEdit, setModalEdit] = useState(false);
    const [modalDelete, setModalDelete] = useState(false);
    const [clave, setClave] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [datosPerfil, setDatosPerfil] = useState({
        direccion: "",
        localidad: "",
        partido: "",
        provincia: "",
        email: "",
        telefono: ""
    });
   
const changePassHanbler = (e) => {
    setClave(e.target.value);
}

    const changeHandler = (e) => {
        const { name, value } = e.target;
          setDatosPerfil({
          ...datosPerfil,
          [name]: value,
        });
      };
    
    

    const toggleEdit = () => {
        setModalEdit(!modalEdit);
        setModalDelete(false);}

    const toggleDelete = () => {
            setModalDelete(!modalDelete);
            setClave("");
            setErrorMessage("");
            setModalEdit(false);}

    
    const cargaCiudadanoPrincipal =() => {
        EstacionamientoService.obtenerDatosCiudadano(localStorage.getItem("hashLogin"))
        .then((resp)=>{
            setUserData(resp.data);
            setDatosPerfil({
                direccion: resp.data.Direccion,
                localidad: resp.data.Niv3,
                partido: resp.data.Niv2,
                provincia: resp.data.Niv1,
                email: resp.data.Email,
                telefono: resp.data.Celular
            })
            setLoading(false);
        })
        .catch(()=>{
            setLoading(false);
        })
    }
    
    useEffect(()=>{
        
      cargaCiudadanoPrincipal();
    },[])

    const formatFecha = (fecha) => {
        if (fecha == undefined)
        return ""
    else
        return fecha.substring(8,10)+"/"+fecha.substring(5,7)+"/"+fecha.substring(0,4);
    }

    const formatDireccion =(calle, prov, localidad, barrio) =>{
        var retorno = calle;
        if (prov) retorno+= ", "+prov;
        if (localidad) retorno+=", "+localidad;
        if (barrio) retorno+=", "+barrio;
        return retorno;
    }


    const doChanges = () => {
        var userDataModificar ={
            hash_login : localStorage.getItem("hashLogin"),
            direccion : datosPerfil.direccion,
            celular : datosPerfil.telefono,
            email : datosPerfil.email,
            niv1 : datosPerfil.localidad,
            niv2 : datosPerfil.partido,
            niv3 : datosPerfil.provincia,
        }
        EstacionamientoService.editarPerfilUsuario(userDataModificar)
        .then(()=>{
            cargaCiudadanoPrincipal();
            toggleEdit();
        })
        .catch(()=>{
            setLoading(false);
            toggleEdit();
            cargaCiudadanoPrincipal();
        });
        setLoading(true);
    }

    const doDeletion = () => {
        var deleteData ={
            hash_login : localStorage.getItem("hashLogin"),
            password : clave
        }
        EstacionamientoService.borrarPerfilUsuario(deleteData)
        .then(()=>{
            setLoading(false)
            localStorage.removeItem("hashLogin");
            navigate("/");

        })
        .catch((error)=>{
            console.log(error);
            setLoading(false);
            setErrorMessage(error.response.data.message);
        });
        setLoading(true);
    }
    
    const continueClick = () => {
        
        doChanges();
    }

  
    
    return (
        <>
        <Modal isOpen={modalEdit} toggle={toggleEdit} modalClassName={bodySiteM.modalposEdit} contentClassName={bodySiteM.modalinfo}>
   
               <ModalBody className={bodySiteM.modalinfo}>
                 <div class="row">
                    <div class="col alignToLeft">
                 Direcci&oacute;n
                 </div>
                 </div>
                 <div class="row">
                    <div class="col alignToLeft">
                    <input class="inputTextMini inputEditMax" type="text" name="direccion" id="direccion" placeholder="direccion" onChange = {changeHandler}value={datosPerfil.direccion}/>
        
                     </div>
                 </div>
                 <div class="row">
                    <div class="col alignLeft">
                    <input class="inputTextMini inputEditMin" type="text" name="localidad" id="localidad" placeholder="localidad" onChange = {changeHandler}value={datosPerfil.localidad}></input>
                    &nbsp;
                    <input class="inputTextMini inputEditMin" type="text" name="partido" id="partido" placeholder="partido" onChange = {changeHandler}value={datosPerfil.partido}></input>
                   &nbsp;
                    <input class="inputTextMini inputEditMin" type="text" name="provincia" id="provincia" placeholder="provincia" onChange = {changeHandler}value={datosPerfil.provincia}></input>
                    </div>
                    </div>
                    <div class="row">
                    <div class="col alignToLeft">
                        Telefono
                 </div>
                 </div>
                 <div class="row">
                    <div class="col alignLeft">
                    <input class="inputTextMini inputEditMax" type="number" name="telefono" id="telefono" placeholder="telefono" onChange = {changeHandler}value={datosPerfil.telefono}/>
                    </div>
                     </div>
                     <div class="row">
                    <div class="col alignToLeft">
                        Email
                 </div>
                 </div>
                 <div class="row">
                    <div class="col alignLeft" >
                    <input class="inputTextMini inputEditMax" type="text" name="email" id="email" placeholder="email" onChange = {changeHandler}value={datosPerfil.email}/>
                    </div>
                     </div>
                     {loading?<Spinner color="danger" align="center"/>:""}
               </ModalBody>
               <ModalFooter>
                <div class="col alignLeft">
               <Button  className={bodySiteM.buttonInvertedDangerMini}onClick={continueClick}>Editar</Button></div>
               <div class="col alignRight">
               <Button  className={bodySiteM.buttonInvertedDangerMini}onClick={toggleEdit}>Cancelar</Button></div>
               </ModalFooter>
               
               </Modal>

               <Modal isOpen={modalDelete} toggle={toggleDelete} modalClassName={bodySiteM.modalposDelete} contentClassName={bodySiteM.modalinfo}>
   
   <ModalBody className={bodySiteM.modalinfo}>
     <div class="row">
        <div class="col alignToLeft">
     Esta seguro de eliminar definitivamente la cuenta?
     </div>
     </div>
    
     <div class="row">
                    <div class="col alignToLeft textMini">
                        Ingrese su contraseña para confirmar
                 </div>
                 </div>
                 <div class="row">
                    <div class="col alignLeft">
                    <input class="inputTextMini inputEditMin" type="password" name="password" id="password" placeholder="Clave" onChange={changePassHanbler} value={clave}/>
                    </div>
                     </div>
                     <p class="errorText" align="center">{errorMessage}</p>
        {loading ?  <div align="center">
   <Spinner color="light" align="center"/></div>:<></>}
   

       
   </ModalBody>
   <ModalFooter>
    <div class="col alignLeft">
   <Button  className={bodySiteM.buttonInvertedDangerMini}onClick={doDeletion}>Eliminar</Button></div>
   <div class="col alignRight">
   <Button  className={bodySiteM.buttonInvertedDangerMini}onClick={toggleDelete}>Cancelar</Button></div>
   </ModalFooter>
   
   </Modal>
       <div class="container text-center indexContent" >
            <div class="row">
                <div class="col">
                    <img className="imageClipProfile" src="./miperfil-02.svg"/>
                </div>
            </div>
           
      <div class="row">
        <div class="col profileName">

        <img src="./miperfil-04.png"  width="30px"/>
       <span class="spacingProfile">
            {loading?"...": userData.Nombre + " "+userData.Apellido}
              </span>
            </div>
            </div>
            <div class="row">
                <div class="col profileItem">
                    <span class="profileBold">DNI: </span>  {loading?"...": userData.DNI} 
                </div>
            </div>
            <div class="row">
                <div class="col profileItem">
                    <span class="profileBold">Sexo: </span> {loading?"...": userData.Sexo} 
                </div>
            </div>
            <div class="row">
                <div class="col profileItem">
                    <span class="profileBold">Fecha Nacimiento</span> {loading?"...": formatFecha(userData.FechaNacimiento)} 
                </div>
            </div>
            <div class="row">
                <div class="col">&nbsp;</div>
            </div>
            <div class="row">
                <div class="col profileItem">
                    <span class="profileBold">Direcci&oacute;n</span> {loading?"...": formatDireccion(userData.Direccion,userData.Niv1,userData.Niv2,userData.Niv3)} 
                    &nbsp;&nbsp;<img src="./miperfil-03.svg"  width="18px" onClick={toggleEdit}/>
                </div>
            </div>
            <div class="row">
                <div class="col profileItem">
                    <span class="profileBold">Celular</span> {loading?"...": userData.Celular}
                    &nbsp;&nbsp;<img src="./miperfil-03.svg"  width="18px" onClick={toggleEdit}/>
                </div>
            </div>
            <div class="row">
                <div class="col profileItem">
                    <span class="profileBold">Email</span> {loading?"...": userData.Email}
                    &nbsp;&nbsp;<img src="./miperfil-03.svg"  width="18px" onClick={toggleEdit}/>  
                </div>
            </div>
            <div class="row">
            <div class="col profileName">
                <button class="buttonSemiClipInverted" onClick={toggleDelete}>Eliminar mi usuario </button>
     
                
    </div> 
        </div>
        </div>
        
        </>

    );
}

export default MiCuentaSites;